module.exports = __webpack_public_path__ + "static/media/mastercard.59561288.svg";